<template>
  <article class="section section--full-width">
    <header class="section__header">
      <h1 class="section__title">Relatórios</h1>
    </header>

    <section class="section__wrapper">
      <ul class="section__nav tabbed-nav">
        <li
          v-for="(report, index) in reports"
          :key="`report_${index}`"
          :class="currentReport.params.type === report.params.type ? 'active' : ''"
          class="tabbed-nav__item"
        >
          <router-link
            :to="{ name: 'DoctorReports', params: { type: report.params.type } }"
            class="tabbed-nav__link"
          >
            {{ report.name }}
          </router-link>
        </li>
      </ul>

      <transition
        name="fade"
        mode="out-in"
        tag="div"
        class="section__body"
      >
        <component :is="currentReport.component.name" />
      </transition>
    </section>
  </article>
</template>

<script>
import examsProcedures from '@/components/layout/reports/examsProcedures'
import performance from '@/components/layout/reports/performance'
import overdue from '@/components/layout/reports/overdue'
import { mapGetters } from 'vuex'

export default {
  name: 'DrReports',

  components: {
    examsProcedures,
    performance,
    overdue
  },

  data () {
    return {
      reports: [
        {
          name: 'Exames/Procedimentos',
          type: 'tableProcedures',
          component: { name: 'examsProcedures' },
          params: { type: 'exams-procedures' }
        },
        {
          name: 'Desempenho',
          type: 'performance',
          component: { name: 'performance' },
          params: { type: 'performance' }
        },
        {
          name: 'Inadimplência',
          type: 'overdue',
          component: { name: 'overdue' },
          params: { type: 'overdue' }
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
      office: 'getCurrentOffice'
    }),

    currentReport () {
      return this.reports.find(report => report.params.type === this.$route.params.type)
    }
  },

  created () {
    if (!this.$route.params.type) {
      this.$router.push({ name: 'DoctorReports', params: { type: 'exams-procedures' } })
    }
  }
}
</script>
